import classNames from 'classnames';
import OrderSummaryDetails from 'components/common/OrderSummaryDetails';
import { currencyFormat } from 'helpers/utils';
import { Card } from 'react-bootstrap';

interface OrderDetailsSummaryCardProps {
  className?: string;
  orderTotal?: number;
  orderDetails?: any;
}

const OrderDetailsSummaryCard = ({ 
  className, 
  orderTotal = 0,
  orderDetails
}: OrderDetailsSummaryCardProps) => {
  return (
    <Card className={classNames(className)}>
      <Card.Body>
        <Card.Title as="h3" className="mb-4">
          Summary
        </Card.Title>

        <div className="border-bottom border-translucent border-dashed mb-4">
          <OrderSummaryDetails orderDetails={orderDetails} />
        </div>
        <div className="d-flex justify-content-between">
          <h4 className="mb-0">Total:</h4>
          <h4 className="mb-0">
            {currencyFormat(orderTotal, { minimumFractionDigits: 2 })}
          </h4>
        </div>
      </Card.Body>
    </Card>
  );
};

export default OrderDetailsSummaryCard;
